import { transformSDKFloatToRESTFloat } from '@wix/sdk-runtime/transformations/float';
import { transformRESTFloatToSDKFloat } from '@wix/sdk-runtime/transformations/float';
import { transformSDKTimestampToRESTTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/metro-runtime';
function resolveComWixpressBookingsConfirmatorV2ConfirmatorUrl(opts) {
    const domainToMappings = {
        'www.wixapis.com': [
            {
                srcPath: '/_api/bookings-confirmator/v2/bookings/confirmation',
                destPath: '/v2/bookings/confirmation',
            },
            {
                srcPath: '/bookings/v2/confirmation',
                destPath: '/v2/confirmation',
            },
            {
                srcPath: '/bookings/v2/bulk/confirmation',
                destPath: '/v2/bulk/confirmation',
            },
            {
                srcPath: '/bookings/v2/bulk/bookings/confirmOrDecline',
                destPath: '/v2/bulk/bookings/confirmOrDecline',
            },
            {
                srcPath: '/_api/bookings-confirmator/v2/bulk/confirmation',
                destPath: '/v2/bulk/confirmation',
            },
            {
                srcPath: '/_api/bookings-confirmator/v2/bulk/bookings/confirmOrDecline',
                destPath: '/v2/bulk/bookings/confirmOrDecline',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings }));
}
function resolveComWixpressBookingsBookingsV2BookingsUrl(opts) {
    const domainToMappings = {
        _: [
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/multi_service_bookings',
                destPath: '/v2/multi_service_bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bulk/multi_service_bookings',
                destPath: '/v2/bulk/multi_service_bookings',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/multi_service_bookings',
                destPath: '/v2/multi_service_bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bulk/multi_service_bookings',
                destPath: '/v2/bulk/multi_service_bookings',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
            {
                srcPath: '/bookings/v2/bookings',
                destPath: '/v2/bookings',
            },
            {
                srcPath: '/bookings/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/bookings-service/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/bookings-service/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/bookings-service/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/bookings-service/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/bookings-service',
                destPath: '/v2/bookings',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings }));
}
/**
 * Creates a booking.
 *
 *
 * To create a booking for an appointment or a session of a class, pass a booking with the relevant `slot`.
 *
 * To create a booking for the entire course, pass a booking with the relevant `schedule`.
 * You can use Query Availability to check the availability beforehand.
 *
 * If you create a booking for an existing session, we recommend that you only pass `slot.sessionId`.
 * Then, any specified slot details are calculated.
 *
 * If you create a booking for a new session, we recommend to call Query Availability first.
 * Then, pass the retrieved `availability.slot` object as the BookedEntity.Slot of the booking in the request.
 *
 * Bookings are created with a status of `CREATED`.
 * `CREATED` bookings don't appear on the business calendar and don't affect a related schedule's availability.
 *
 * To create a booking with a given status, pass a booking with the wanted status.
 * This is only permitted for site Owners.
 *
 * You can pass a `participantNotification.message` to notify the customer of the booking with a message.
 * It's also necessary to pass `participantNotification.notifyParticipants`as `true` to send the message.
 *
 * You can pass `sendSmsReminder` as `true`, if you want an SMS reminder to be sent to the phone number specified in the ContactDetails, 24 hours before the session starts.
 *
 * When creating a booking you must pass either `participantsChoices` or `totalParticipants`. If you pass `participantsChoices`, all the
 * provided choices must exist for the service, otherwise the call returns an `INVALID_SERVICE_CHOICES` error.
 *
 * When creating a booking, you can pass `selectedPaymentOption`.
 * This specifies which payment method the customer plans to use.
 * But it's possible for them to later use another supported payment method.
 *
 * You can skip the checkout and payment flow if you call Confirm Or Decline Booking otherwise, after you create the booking, you can use the
 * Wix eCommerce APIs (coming soon) for the checkout and payment flow or use a different service for checkout.
 */
export function createBooking(payload) {
    function __createBooking({ host }) {
        const serializedData = transformPaths(payload, [
            {
                transformFn: transformSDKTimestampToRESTTimestamp,
                paths: [
                    { path: 'booking.createdDate' },
                    { path: 'booking.startDate' },
                    { path: 'booking.endDate' },
                    { path: 'booking.updatedDate' },
                    { path: 'booking.canceledDate' },
                ],
            },
            {
                transformFn: transformSDKFloatToRESTFloat,
                paths: [
                    { path: 'booking.contactDetails.fullAddress.geocode.latitude' },
                    { path: 'booking.contactDetails.fullAddress.geocode.longitude' },
                ],
            },
        ]);
        const metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.CreateBooking',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings',
                data: serializedData,
                host,
            }),
            data: serializedData,
            transformResponse: (payload) => transformPaths(payload, [
                {
                    transformFn: transformRESTTimestampToSDKTimestamp,
                    paths: [
                        { path: 'booking.createdDate' },
                        { path: 'booking.startDate' },
                        { path: 'booking.endDate' },
                        { path: 'booking.updatedDate' },
                        { path: 'booking.canceledDate' },
                    ],
                },
                {
                    transformFn: transformRESTFloatToSDKFloat,
                    paths: [
                        { path: 'booking.contactDetails.fullAddress.geocode.latitude' },
                        { path: 'booking.contactDetails.fullAddress.geocode.longitude' },
                    ],
                },
            ]),
        };
        return metadata;
    }
    return __createBooking;
}
/**
 * Creates multiple bookings.
 *
 *
 * See [`createBooking()`](https://www.wix.com/velo/reference/wix-bookings-v2/bookings/createbooking) documentation.
 *
 * If for any of the bookings required fields were not passed on the request or if the caller doesn't have the required permissions to create such booking, the call will fail.
 * If the request contains unavailable bookings, the call will be completed successfully, but the unavailable bookings will not be created and will be considered as a failure on the response.
 */
export function bulkCreateBooking(payload) {
    function __bulkCreateBooking({ host }) {
        const serializedData = transformPaths(payload, [
            {
                transformFn: transformSDKTimestampToRESTTimestamp,
                paths: [
                    { path: 'createBookingsInfo.booking.createdDate' },
                    { path: 'createBookingsInfo.booking.startDate' },
                    { path: 'createBookingsInfo.booking.endDate' },
                    { path: 'createBookingsInfo.booking.updatedDate' },
                    { path: 'createBookingsInfo.booking.canceledDate' },
                ],
            },
            {
                transformFn: transformSDKFloatToRESTFloat,
                paths: [
                    {
                        path: 'createBookingsInfo.booking.contactDetails.fullAddress.geocode.latitude',
                    },
                    {
                        path: 'createBookingsInfo.booking.contactDetails.fullAddress.geocode.longitude',
                    },
                ],
            },
        ]);
        const metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.BulkCreateBooking',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bulk/bookings/create',
                data: serializedData,
                host,
            }),
            data: serializedData,
            transformResponse: (payload) => transformPaths(payload, [
                {
                    transformFn: transformRESTTimestampToSDKTimestamp,
                    paths: [
                        { path: 'results.item.createdDate' },
                        { path: 'results.item.startDate' },
                        { path: 'results.item.endDate' },
                        { path: 'results.item.updatedDate' },
                        { path: 'results.item.canceledDate' },
                    ],
                },
                {
                    transformFn: transformRESTFloatToSDKFloat,
                    paths: [
                        {
                            path: 'results.item.contactDetails.fullAddress.geocode.latitude',
                        },
                        {
                            path: 'results.item.contactDetails.fullAddress.geocode.longitude',
                        },
                    ],
                },
            ]),
        };
        return metadata;
    }
    return __bulkCreateBooking;
}
/**
 * Reschedules a booking to a different slot or session.
 *
 *
 * You can only reschedule bookings for appointments or classes, you can't
 * reschedule course bookings.
 *
 * The old session is removed from the calendar and the new session is
 * added.
 *
 * If you reschedule a booking for a class session the new session must be an
 * existing session for the same class.
 *
 * You can pass a `participantNotification.message` to notify the customer of
 * the rescheduling. You also need to pass `participantNotification.notifyParticipants`
 * as `true` to actually send the message.
 *
 * In case the service has
 * variants, you can call this endpoint to update the booking's `totalParticipants` or `participantsChoices`.
 * If you provide `participantsChoices`, all of the provided choices must exist for
 * the service. Otherwise, the call returns an `INVALID_SERVICE_CHOICES` error.
 * If you omit `participantsChoices` in the request, the existing choices are
 * kept and not replaced with an empty object.
 *
 * <!-- INTERNAL PERMISSION COMMENT:
 * You need to have the `BOOKINGS.NUMBER_OF_PARTICIPANTS_UPDATE` permission
 * to reschedule bookings including `participantsInfo`.
 * <!--END: INTERNAL PERMISSION COMMENT-->
 *
 * In case you want to reschedule a booking on behalf of a customer, we recommend
 * to pass `flowControlSettings.ignoreReschedulePolicy` as `false`. This
 * ensures that the rescheduling is validated against the service's rescheduling
 * policy.
 */
export function rescheduleBooking(payload) {
    function __rescheduleBooking({ host }) {
        const metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.RescheduleBooking',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/{bookingId}/reschedule',
                data: payload,
                host,
            }),
            data: payload,
            transformResponse: (payload) => transformPaths(payload, [
                {
                    transformFn: transformRESTTimestampToSDKTimestamp,
                    paths: [
                        { path: 'booking.createdDate' },
                        { path: 'booking.startDate' },
                        { path: 'booking.endDate' },
                        { path: 'booking.updatedDate' },
                        { path: 'booking.canceledDate' },
                    ],
                },
                {
                    transformFn: transformRESTFloatToSDKFloat,
                    paths: [
                        { path: 'booking.contactDetails.fullAddress.geocode.latitude' },
                        { path: 'booking.contactDetails.fullAddress.geocode.longitude' },
                    ],
                },
            ]),
        };
        return metadata;
    }
    return __rescheduleBooking;
}
/**
 * Confirms a booking request and changes the booking status to `CONFIRMED`.
 *
 *
 * Calling this method doesn't check whether a slot or schedule is still
 * available at this time.
 *
 * You can only confirm bookings for services that require the owner's manual
 * approval for bookings and that have a status of `PENDING`.
 *
 * For appointment services the slot may become unavailable, depending on the
 * [service's](https://support.wix.com/en/article/creating-the-right-booking-service-for-your-business)
 * `policy.bookingApprovalPolicy.requestsAffectsAvailability`.
 *
 * Calling this method also changes the
 * [session's](https://www.wix.com/velo/reference/wix-bookings-backend/sessions/getsession)
 * `participants.approvalStatus` to `APPROVED`.
 *
 * You can pass a `participantNotification.message` to notify the customer of
 * the confirmation. You also need to pass `participantNotification.notifyParticipants`
 * as `true` to actually send the message.
 *
 * Bookings are automatically confirmed when the
 * service is configured to automatically confirm
 * bookings and the [eCommerce order](https://www.wix.com/velo/reference/wix-ecom-backend/orders)
 * has been approved. The slot's or schedule's availability is checked just
 * before confirming the booking as part of the automatic flow.
 */
export function bookingsConfirmBooking(payload) {
    function __bookingsConfirmBooking({ host }) {
        const metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.ConfirmBooking',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/{bookingId}/confirm',
                data: payload,
                host,
            }),
            data: payload,
            transformResponse: (payload) => transformPaths(payload, [
                {
                    transformFn: transformRESTTimestampToSDKTimestamp,
                    paths: [
                        { path: 'booking.createdDate' },
                        { path: 'booking.startDate' },
                        { path: 'booking.endDate' },
                        { path: 'booking.updatedDate' },
                        { path: 'booking.canceledDate' },
                    ],
                },
                {
                    transformFn: transformRESTFloatToSDKFloat,
                    paths: [
                        { path: 'booking.contactDetails.fullAddress.geocode.latitude' },
                        { path: 'booking.contactDetails.fullAddress.geocode.longitude' },
                    ],
                },
            ]),
        };
        return metadata;
    }
    return __bookingsConfirmBooking;
}
/**
 * Updates the extended fields for a booking.
 *
 *
 * Extended fields must first be configured in the [Wix Developers Center](https://dev.wix.com/app-selector?title=Select+an+App&primaryButtonText=Select+Site&actionUrl=https%3A%2F%2Fdev.wix.com%2Fapps%2F%7BappId%7D%2Fextensions).
 *
 * Learn more about setting up extended fields with [schema plugins](https://dev.wix.com/docs/build-apps/develop-your-app/extensions/backend-extensions/schema-plugins/about-schema-plugin-extensions).
 */
export function updateExtendedFields(payload) {
    function __updateExtendedFields({ host }) {
        const metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.UpdateExtendedFields',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/{id}/update_extended_fields',
                data: payload,
                host,
            }),
            data: payload,
        };
        return metadata;
    }
    return __updateExtendedFields;
}
/**
 * Declines a `PENDING` booking request and changes the booking status to
 * `DECLINED`.
 *
 * Calling this method also changes the
 * [session's](https://www.wix.com/velo/reference/wix-bookings-backend/sessions/getsession)
 * `participants.approvalStatus` to `DECLINED`.
 *
 * You can only decline bookings for services that require the owner's manual
 * approval for bookings and that have a status of `PENDING`.
 *
 * You can pass a `participantNotification.message` to notify the customer of
 * the decline. You also need to pass `participantNotification.notifyParticipants`
 * as `true` to actually send the message.
 */
export function bookingsDeclineBooking(payload) {
    function __bookingsDeclineBooking({ host }) {
        const metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.DeclineBooking',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/{bookingId}/decline',
                data: payload,
                host,
            }),
            data: payload,
            transformResponse: (payload) => transformPaths(payload, [
                {
                    transformFn: transformRESTTimestampToSDKTimestamp,
                    paths: [
                        { path: 'booking.createdDate' },
                        { path: 'booking.startDate' },
                        { path: 'booking.endDate' },
                        { path: 'booking.updatedDate' },
                        { path: 'booking.canceledDate' },
                    ],
                },
                {
                    transformFn: transformRESTFloatToSDKFloat,
                    paths: [
                        { path: 'booking.contactDetails.fullAddress.geocode.latitude' },
                        { path: 'booking.contactDetails.fullAddress.geocode.longitude' },
                    ],
                },
            ]),
        };
        return metadata;
    }
    return __bookingsDeclineBooking;
}
/**
 * Cancels a booking.
 *
 *
 * The booking status changes to `CANCELED`.
 *
 * If the booking was for an appointment, the corresponding session is
 * deleted from the business calendar.
 *
 * If the booking was for a class or course, the participants are removed
 * from the class session or the course. But the course or class session
 * remains on the business calendar.
 *
 * You can pass a `participantNotification.message` to notify the customer of
 * the cancelation. You also need to pass `participantNotification.notifyParticipants`
 * as `true` to actually send the message.
 *
 * In case you want to cancel a booking on behalf of a customer, we recommend
 * to pass `flowControlSettings.ignoreCancellationPolicy` as `false`. This
 * ensures that the cancelation is validated against the service's cancelation
 * policy.
 */
export function bookingsCancelBooking(payload) {
    function __bookingsCancelBooking({ host }) {
        const metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.CancelBooking',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/{bookingId}/cancel',
                data: payload,
                host,
            }),
            data: payload,
            transformResponse: (payload) => transformPaths(payload, [
                {
                    transformFn: transformRESTTimestampToSDKTimestamp,
                    paths: [
                        { path: 'booking.createdDate' },
                        { path: 'booking.startDate' },
                        { path: 'booking.endDate' },
                        { path: 'booking.updatedDate' },
                        { path: 'booking.canceledDate' },
                    ],
                },
                {
                    transformFn: transformRESTFloatToSDKFloat,
                    paths: [
                        { path: 'booking.contactDetails.fullAddress.geocode.latitude' },
                        { path: 'booking.contactDetails.fullAddress.geocode.longitude' },
                    ],
                },
            ]),
        };
        return metadata;
    }
    return __bookingsCancelBooking;
}
/**
 * Updates the number of participants for a booking.
 *
 *
 * You can only update the number of participants for class and course
 * bookings, you can't update it for appointment bookings.
 *
 * Calling this method also changes the
 * [session's](https://www.wix.com/velo/reference/wix-bookings-backend/sessions/getsession)
 * `totalNumberOfParticipants`.
 *
 * When updating the number of participants for a booking you must pass either
 * `participantsChoices` or `totalParticipants`. If you pass `participantsChoices`
 * for services that have variants,
 * all of the provided choices must exist for the service. Otherwise, the
 * call returns an `INVALID_SERVICE_CHOICES` error.
 */
export function bookingsUpdateNumberOfParticipants(payload) {
    function __bookingsUpdateNumberOfParticipants({ host }) {
        const metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.UpdateNumberOfParticipants',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/{bookingId}/update_number_of_participants',
                data: payload,
                host,
            }),
            data: payload,
            transformResponse: (payload) => transformPaths(payload, [
                {
                    transformFn: transformRESTTimestampToSDKTimestamp,
                    paths: [
                        { path: 'booking.createdDate' },
                        { path: 'booking.startDate' },
                        { path: 'booking.endDate' },
                        { path: 'booking.updatedDate' },
                        { path: 'booking.canceledDate' },
                    ],
                },
                {
                    transformFn: transformRESTFloatToSDKFloat,
                    paths: [
                        { path: 'booking.contactDetails.fullAddress.geocode.latitude' },
                        { path: 'booking.contactDetails.fullAddress.geocode.longitude' },
                    ],
                },
            ]),
        };
        return metadata;
    }
    return __bookingsUpdateNumberOfParticipants;
}
/**
 * Use `confirmOrDeclineBooking()` to determine if the booking is valid, payment is received, and the booking can be processed.
 * Call `confirmOrDeclineBooking()` after checkout or after calling `createBooking()` to verify the booking.
 *
 * + If a session is valid and payment is received, the booking is visible on the calendar.
 * + If a session is double booked, `confirmOrDeclineBooking()` can catch this and decline the duplicate booking, the booking is not visible on the calendar.
 */
export function confirmOrDeclineBooking(payload) {
    function __confirmOrDeclineBooking({ host }) {
        const metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.confirmator.v2.Confirmator.ConfirmOrDeclineBooking',
            url: resolveComWixpressBookingsConfirmatorV2ConfirmatorUrl({
                protoPath: '/v2/confirmation/{bookingId}:confirmOrDecline',
                data: payload,
                host,
            }),
            data: payload,
            transformResponse: (payload) => transformPaths(payload, [
                {
                    transformFn: transformRESTTimestampToSDKTimestamp,
                    paths: [
                        { path: 'booking.createdDate' },
                        { path: 'booking.startDate' },
                        { path: 'booking.endDate' },
                        { path: 'booking.updatedDate' },
                        { path: 'booking.canceledDate' },
                    ],
                },
                {
                    transformFn: transformRESTFloatToSDKFloat,
                    paths: [
                        { path: 'booking.contactDetails.fullAddress.geocode.latitude' },
                        { path: 'booking.contactDetails.fullAddress.geocode.longitude' },
                    ],
                },
            ]),
        };
        return metadata;
    }
    return __confirmOrDeclineBooking;
}
//# sourceMappingURL=bookings-v2-booking-bookings.http.js.map